module.exports = __webpack_public_path__ + "media/mosaics/Mosaics-sm-b2396663.jpg";